import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { useGetCart } from "@/features/cart/api/hooks/use-get-cart";
import { useCartStore } from "@/features/cart/components/cart-provider";

// When a user clicks on a link in an abandoned cart reminder email, they are redirected to the cart page with a URL parameter "configuration".
// This parameter contains the ID of the abandoned cart. The hook reads this parameter, fetches the corresponding cart configuration,
// and populates the cart state with the abandoned cart's data.
export const usePopulateAbandonedCart = () => {
  const searchParams = useSearchParams();
  const cartStore = useCartStore((state) => state);
  const [cartId, setCartId] = useState<string | null>(null);
  const { data: cartData, isFetching: isCartPopulating } = useGetCart({
    id: cartId || "",
    options: {
      enabled: !!cartId,
    },
  });

  useEffect(() => {
    const configuration = searchParams.get("configuration");
    if (configuration) {
      setCartId(configuration);
    }
  }, [searchParams]);

  useEffect(() => {
    if (cartData && cartId) {
      cartStore.setCartId(cartId);
      cartStore.setCart(cartData);
    }
  }, [cartData, cartId, cartStore.setCartId, cartStore.setCart]);

  return {
    isCartPopulating,
  };
};
